<template lang="html">
  <section class="sol_country">
    <b-card header="Market" header-bg-variant="primary" header-text-variant="light" id="market">
      <b-card-text>
        <b-row>
          <b-col class="col-lg-1 pt-2">Market:</b-col>
          <b-col class="col-lg-3" v-if="getCurUser">
            <b-select v-model="selectedCountry" :disabled="countries.length == 1">
              <b-form-select-option :value="country" v-for="country in countries" :selected="countries.length == 1">{{ country.id + ' - ' + country.description }}</b-form-select-option>
            </b-select>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col class="col-lg-4"></b-col>
          <b-col class="col-lg-8">
            <span class="float-right">
              <b-button variant="primary mr-1" @click="fillTaxes()"><i class="mdi mdi-refresh"></i>Refresh</b-button>
            </span>
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>
    <b-card header="Taxes" header-bg-variant="primary" header-text-variant="light" id="taxes" class="mt-4">
      <template v-if="selectedCountry && selectedCountry.solEnable">
        <b-card-text>
          <b-row>
            <b-col class="col-lg-2">Code</b-col>
            <b-col class="col-lg-3">B2C</b-col>
            <b-col class="col-lg-3">B2B</b-col>
            <b-col class="col-lg-3">B2E</b-col>
            <b-col class="col-lg-1">Delete</b-col>
          </b-row>
        </b-card-text>
        <b-card-text v-for="(taxe, i) in taxes">
          <b-row>
            <b-col class="col-lg-2">
              <input class="col-lg-9" type="text" v-model="taxe.find(t => t.taxType == 'B2C').taxDescription" />
            </b-col>
            <b-col class="col-lg-3">
              <input class="col-lg-9" type="text" min="0" max="100000" v-on:input="checkInsertNum(taxe.find(t => t.taxType == 'B2C'))" @keypress="isNumber($event)" v-model="taxe.find(t => t.taxType == 'B2C').taxValue" />
            </b-col>
            <b-col class="col-lg-3">
              <input class="col-lg-9" type="text" min="0" max="100000" v-on:input="checkInsertNum(taxe.find(t => t.taxType == 'B2B'))" @keypress="isNumber($event)" v-model="taxe.find(t => t.taxType == 'B2B').taxValue" />
            </b-col>
            <b-col class="col-lg-3">
              <input class="col-lg-9" type="text" min="0" max="100000" v-on:input="checkInsertNum(taxe.find(t => t.taxType == 'B2E'))" @keypress="isNumber($event)" v-model="taxe.find(t => t.taxType == 'B2E').taxValue" />
            </b-col>
            <b-col class="col-lg-1">
              <b-button class="p-1 m-auto" size="sm" style="max-width: 2.875rem;" variant="danger" @click="deleteTaxe(taxe, i)">
                <i class="mdi mdi-delete"></i>
              </b-button>
            </b-col>
          </b-row>
        </b-card-text>
        <b-card-text>
          <b-row>
            <div class="col-sm-2 pt-2"></div>
            <!-- Colonne bottoni-->
            <b-col class="col-lg-12">
              <span class="float-right">
                <b-button variant="primary mr-1" @click="fillTaxes()">
                  <i class="mdi mdi-rotate-left"></i>
                  Rollback
                </b-button>
                <b-button variant="primary mr-1" @click="addTaxes()">
                  <i class="mdi mdi-plus"></i>
                  Add
                </b-button>
                <b-button @click="saveSolTaxesData()" variant="primary mr-1">Save</b-button>
              </span>
            </b-col>
          </b-row>
        </b-card-text>
      </template>
    </b-card>
  </section>
</template>
<script lang="js">
import {mapActions, mapGetters} from "vuex";
import mixin from '../../mixin/mixin.js'
export default {
  name: 'sol_country',
  mixins: [mixin],
  methods: {
    isNumber(evt = KeyboardEvent) {
      const keysAllowed  = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'];
      const keyPressed = evt.key;
      
      if (!keysAllowed.includes(keyPressed)) {
        evt.preventDefault()
      }
    },
    checkInsertNum(source){
      let data = source.taxValue;
      /*if(data == null || !data) {
        data = 0.00;
      } else if(data && parseInt(data) <= 0){
        data = 0.00;
      }*/
      source.taxValue = data;
    },
    fillTaxes () {
      this.setSpinnerStatus(true);
      this.axios.get('/ccb/auth/fe/solCountryTaxes/' + this.selectedCountry.id, this.authHeader)
        .then(response => {
          if(response.data.length > 0)
            this.taxes = Object.values(Object.groupBy(response.data, ({ taxDescription }) => taxDescription))
          else
            this.taxes = []
        }).catch(error => {
          this.$bvModal.msgBoxOk(error.message, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
        }).finally(() => {
          this.setSpinnerStatus(false);
        })
    },
    addTaxes() {
      var item = {id: null, idCountry: this.selectedCountry.id, taxValue: 0.00, taxDescription: null, taxType: null};
      this.taxes.push([{...item, taxType: 'B2C'}, {...item, taxType: 'B2B'}, {...item, taxType: 'B2E'}]);
    },
    saveSolTaxesData() {
      var error = false;
      for(var tax of this.taxes) {
        if(tax[0].taxDescription) {
          tax.forEach(t => {
            t.taxDescription = tax[0].taxDescription;
          })
        } else {
          this.$bvModal.msgBoxOk("Description required", {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
          error = true;
          break;
        }
        if(this.taxes.filter(t => t[0].taxDescription == tax[0].taxDescription).length > 1) {
          this.$bvModal.msgBoxOk("Description already present", {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
          error = true;
          break;
        }
      }
      if(!error) {
        this.setSpinnerStatus(true);
        this.axios.put('/ccb/auth/fe/solCountryTaxes/saveSolTaxes', this.taxes.flat(1), this.authHeader)
          .then(response => {
          if(response.status == 200) {
            this.$bvModal.msgBoxOk(response.data.message, {
              okVariant: 'success',
              hideHeaderClose: false,
              centered: true
            }).then(value => {
              this.fillTaxes();
            })
          }
          }).catch(error => {
            this.$bvModal.msgBoxOk(error.message, {
              okVariant: 'danger',
              hideHeaderClose: false,
              centered: true
            })
          }).finally(e=>{
            this.setSpinnerStatus(false);
          })
      }
    },
    deleteTaxe(taxe, index) {
      if(taxe[0].id) {
        var ids = taxe.map(t => t.id)
        this.setSpinnerStatus(true);
        this.axios.post('/ccb/auth/fe/solCountryTaxes/deleteSolTaxes', ids, this.authHeader)
          .then(response => {
            if(response.status == 200) {
              this.$bvModal.msgBoxOk(response.data.message, {
                okVariant: 'success',
                hideHeaderClose: false,
                centered: true
              }).then(value => {
                this.fillTaxes();
              })
            }
          }).catch(error => {
            this.$bvModal.msgBoxOk(error.message, {
              okVariant: 'danger',
              hideHeaderClose: false,
              centered: true
            })
          }).finally(e=>{
            this.setSpinnerStatus(false);
          })
      } else {
        this.taxes.splice(index, 1);
      }
    },
    ...mapActions([
      'setSpinnerStatus',
      'setCurApp',
      'setSolServiceActive'
    ]),
  },
  data () {
    return {
      taxes: [],
      selectedCountry: null
    }
  },
  computed: {
    countries() {
      return this.getCurUser.countries.filter(country => country.solEnable);
    },
    ...mapGetters([
      'authHeader',
      'getCurUser',
      'getSolServiceActive'
    ])
  },
  mounted() {    
    if(!this.getSolServiceActive)
      this.setCurApp('finco')
    this.selectedCountry = this.countries[0];
    this.fillTaxes();
  },
  watch: {
    selectedCountry(newVal, oldVal) {
      this.fillTaxes();
    }
  }
}
</script>
<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
.collapse {
  border: 1px solid $gray-lightest;
  border-radius: 0.25rem;
}
</style>